module.exports = __webpack_public_path__ + "img/divinewind.986c78c5.webp";